/* 
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

/**
 * @getMinDateForAssets
 * 
 * Returns a number (max 2 decimals) that is the maxHVSAssetDays divided
 * by the passed number for total assets.
 * 
 * @param {number} maxHVSAssetDays: Total number of days that can be queried in CTC
 * @param {number} totalAssets: If calculating the total supported asset days
 *   we need to know how many assets are under consideration. 
 * @returns {number}
 */
export const getMinDaysForAssets = (maxHVSAssetDays, totalAssets): number => {
  return Number((maxHVSAssetDays / totalAssets).toFixed(2));
};

/**
 * This function allows for retrieving the value of a specific filter based on
 * the filters type, either a string or an object.
 */
export const getFilterValue = item => item?.id || item;

/**
  * This function allows for retrieving the label to be displayed for a specific
  * filter based on the filters type, either a string or an object.
  */
export const getFilterLabel = item => item?.name || item;
 
/**
  * This function condenses both getFilterValue and getFilterLabel functions and
  * returns an object containing the filter label and value.
  */
export const resolveFilter = (item: any): any => ({
  value : getFilterValue(item),
  label : getFilterLabel(item)
});
